import axios from '@/libs/api.request'
import Qs from 'qs'

// 根据一级类别获取产品数据列表
export const getProductList = (params) => {
    return axios.request({
        url: 'product',
        method: 'post',
        data: params
    })
}

// 获取所有类别
export const getAllCategory = (params) => {
    return axios.request({
        url: `/category/0`,
        method: 'get',
        params: params
    })
}

// 获取所有类别
export const getCategory = (params) => {
    return axios.request({
        url: `/category/0?type=${params.type}`,
        method: 'get'
    })
}

// 根据类别id 获取筛选条件
export const getCondition = (params) => {
    return axios.request({
        url: '/condition',
        method: 'get',
        params: params
    })
}

// 根据某个筛选属性改变，重新获取所有条件所有属性值
export const afreshFiltrate = (params) => {
    return axios.request({
        url: '/attr_map',
        method: 'post',
        data: params
    })
}

// 根据id获取产品详情
export const getProductDetails = (params) => {
    return axios.request({
        url: `/product/${params.id}`,
        method: 'post'
    })
}

// 根据产品名称搜索
export const searchProductTitle = (params) => {
    return axios.request({
        url: '/product/searchTitle',
        method: 'post',
        data: params
    })
}

// 获取热门搜索标题
export const getProductHotTitle = (params) => {
    return axios.request({
        url: '/product/hotTitle',
        method: 'post',
        data: params
    })
}

// 产品申领表单
export const productApply = (params) => {
    return axios.request({
        url: '/product_apply/create',
        method: 'post',
        data: params,
        transformRequest: [function (data) {
            // 请求数据前，对数据处理
            for (var key in data) {
                if (!data[key]) {
                    delete data[key]
                }
            }
            // console.log('请求的参数', data)
            data = Qs.stringify(data)
            return data
        }]
    })
}

// 视频的浏览记录
export const recordVideo = (params) => {
    return axios.request({
        url: `/video/${params.id}`,
        method: 'post'
    })
}

// psd的浏览记录
export const recordPdf = (params) => {
    return axios.request({
        url: `/pdf/${params.id}`,
        method: 'post'
    })
}

// 用户轨迹记录
export const userTrack = (params) => {
    return axios.request({
        url: '/log/create',
        method: 'post',
        data: params
    })
}

// 申请报价
export const applyQuotation = (params) => {
    return axios.request({
        url: '/product_quoted/create',
        method: 'post',
        data: params
    })
}

// 获取类别详情
export const categoryInfo = (params) => {
    return axios.request({
        url: `/category/info/${params.category_id}`,
        method: 'get'
    })
}
